export enum AssistanceApplicationFileType {
    PhotoId = 'PhotoId',
    ProofOfResidence = 'ProofOfResidence',
    UtilityBill = 'UtilityBill',
    TaxStatement = 'TaxStatement',
    TaxReturns = 'TaxReturns',
    EvictionCourtOrder = 'EvictionCourtOrder',
    VoterRegistration = 'VoterRegistration',
    CheckStub = 'CheckStub',
    UtilityShutoffNotice = 'UtilityShutoffNotice',
    BankStatement = 'BankStatement',
    GovtOrCourtRecord = 'GovtOrCourtRecord',
    W9 = 'W9',
    SsnProof = 'SsnProof',
    EmployerLetter = 'EmployerLetter',
    PensionLetter = 'PensionLetter',
    ArmedForcesAllotment = 'ArmedForcesAllotment',
    ChildSupport = 'ChildSupport',
    UnionFunds = 'UnionFunds',
    GovtBenefitsStatement = 'GovtBenefitsStatement',
    SsiSsdiAwardLetter = 'SsiSsdiAwardLetter',
    TANF = 'TANF',
    UnemploymentAward = 'UnemploymentAward',
    WicSnapAwardLetter = 'WicSnapAwardLetter',
    ProfitLossStatement = 'ProfitLossStatement',
    DelinquentWaterBill = 'DelinquentWaterBill',
    RentLandlordForm = 'RentLandlordForm',
    LeaseAgreement = 'LeaseAgreement',
    LandlordProofOfOwnership = 'LandlordProofOfOwnership',
    DelinquentRentNotice = 'DelinquentRentNotice',
    EvictionNotice = 'EvictionNotice',
    MortgageStatement = 'MortgageStatement',
    MovingExpenseBill = 'MovingExpenseBill',
    AutoPaymentStatement = 'AutoPaymentStatement',
    AutoTitle = 'AutoTitle',
    AutoRepairBill = 'CarRepairBill',
    AutoInsuranceBill = 'AutoInsuranceBill',
    ChildcareBill = 'ChildcareBill',
    ChildEnrollmentProof = 'ChildEnrollmentProof',
    ChildEducationProgressReport = 'ChildEducationProgressReport',
    TuitionBill = 'TuitionBill',
    ChildEducationBill = 'EducationBill',
    ChildTutoringBill = 'ChildTutoringBill',
    ForCaseworkerUseOnly = 'ForCaseworkerUseOnly',
    Other = 'Other',
    ApplianceInvoice = 'ApplicationInvoice',
    HvacPlumbingBidInvoice = 'HvacPlumbingBidInvoice',
    ConstructionBidInvoice = 'ConstructionBidInvoice',
    MoldRemediationInvoice = 'MoldRemediationInvoice',
    StorageStatement = 'StorageStatement',
    OtherDisasterNeeds = 'OtherDisasterNeeds'
}
